import React from "react";
import { ShieldCheck, ArrowRight, Sparkles } from "lucide-react";
import { clinic } from "../mock";

export default function PanelCTA() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pb-20 lg:pb-24">
        <div className="reveal relative overflow-hidden rounded-[28px] hero-gradient text-white p-8 lg:p-14">
          <div
            className="absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.6) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.6) 1px,transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />
          <div className="relative grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-blue-200">
                <Sparkles size={14} /> Para profesionales
              </span>
              <h2 className="font-display font-extrabold text-3xl lg:text-[2.4rem] leading-tight mt-4">
                ¿Eres médico o staff del centro?
              </h2>
              <p className="text-blue-100/80 mt-4 leading-relaxed max-w-lg">
                Accede al Panel Clínico CEOSLUCIA · LucIA para gestionar fichas, solicitudes y
                exámenes en tiempo real, sincronizado con la app móvil.
              </p>
            </div>
            <div className="lg:justify-self-end">
              <a
                href={clinic.panelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 bg-white text-[#0b2545] rounded-full pl-6 pr-4 py-3.5 font-semibold shadow-xl shadow-blue-950/30 hover:bg-blue-50 transition-colors"
              >
                <ShieldCheck size={20} /> Ingresar al Panel Clínico
                <span className="w-9 h-9 rounded-full bg-[#1d6fc0] text-white grid place-items-center group-hover:translate-x-0.5 transition-transform">
                  <ArrowRight size={18} />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
